import {Skeleton} from '@molecules';

export const DaySummaryLoader = () => {
  return (
    <div className="flex flex-col gap-5 pb-8 relative p-4 rounded-xl border border-gray-200 bg-beige-200">
      <Skeleton className="h-[60px] bg-white rounded-xl" />
      <Skeleton className="h-[216px] bg-white rounded-xl" />
      <Skeleton className="h-[100px] bg-white rounded-xl" />
      <Skeleton className="h-[160px] bg-white rounded-xl" />
      <Skeleton className="h-[120px] bg-white rounded-xl" />
    </div>
  );
};
